var map = {
	"./Pursuit Logo.jpeg": 105,
	"./SNHU logo.jpeg": 5017,
	"./Tec de Monterrey logo.jpeg": 3623,
	"./image-placeholder.jpg": 1984,
	"./logo_platzi.png": 9275,
	"./logo_pursuit.png": 145,
	"./logo_southern-new-hampshire-university.webp": 8747,
	"./logo_tecnologico-de-monterrey.jpeg": 5586,
	"./project_bird-sanctuary.png": 2541,
	"./project_budgrt-app.png": 5509,
	"./project_get-it-done.png": 8458,
	"./project_habit-flow.png": 5462,
	"./project_luxury-guitars.JPG": 2511,
	"./project_recipe-app.avif": 8813,
	"./project_reverb-clone.png": 989,
	"./project_scriptum.png": 4086,
	"./project_student-dashboard.jpg": 5855,
	"./project_studio_ghibli.png": 7825,
	"./project_tuner-app.png": 2979,
	"./project_youtube-clone.png": 6854,
	"./yanako-picture.jpg": 1389
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3811;